import { api } from '../index.js'

export default {
  namespaced: true,

  state: {
    contacts: []
  },

  mutations: {
    updateContacts(state, contacts) {
      state.contacts = contacts
    },

    resetContacts(state) {
      state.contacts = []
    }
  },

  actions: {
    async fetchAll({ commit, state }) {
      let [contacts] = await api.contacts.all()
      commit('updateContacts', contacts)
    },

    async search({ commit, state }, query) {
      let [contacts] = await api.contacts.search(query)
      commit('updateContacts', contacts)
    }
  }
}
